const Image = (props) => {

    return <div class="image-imported" style={props.styled}>
        <img src={props.src} /> 
    </div> 
}


export default Image